import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@klarna/bubble-ui';

import { formUtils } from 'moet-core';

type MultiSelectDropdownProps = {
  addValue: (value: string) => void;
  label: string;
  disabled?: boolean;
  options?: { key: string; label: string }[];
  value?: string[];
};

export const MultiSelectDropdown = ({
  label,
  addValue,
  disabled = false,
  options = [],
  value = [],
  ...props
}: MultiSelectDropdownProps & Partial<any>): JSX.Element => {
  const mappedOptions = formUtils.addEmptyDropdownItem(
    options.map(({ key, label }) => ({
      key,
      label,
      disabled: value.includes(key),
    })),
  );

  const isMorFlow =
    props.contractOnboardingType === 'MOR_ONBOARDING_GROUP' ||
    props.contractOnboardingType === 'MOR_ONBOARDING_ENTITY';

  const dropdownOptions =
    isMorFlow && !props.absolutePath.includes('countries')
      ? mappedOptions
      : mappedOptions.sort(({ label: a = '' }, { label: b = '' }) => a.localeCompare(b));

  return (
    <Dropdown
      {...props}
      disabled={disabled}
      label={label}
      options={dropdownOptions}
      onChange={addValue}
      value=""
    />
  );
};

MultiSelectDropdown.propTypes = {
  addValue: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.array,
};
